<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Annotators
            <v-spacer></v-spacer>
            <v-btn medium depressed flat icon color="white" to="annotators/add" v-if="$auth.user().AuthScope.includes('annotation:manage')">
              <v-icon medium>add_circle_outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="filteredHeaders"
            :items="items"
            :rows-per-page-items="[10,25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
            :loading="annotatorsLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ `${props.item.firstName} ${props.item.lastName}` }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNumber }}</td>
                <td>
                  <v-switch
                    hide-details
                    v-model="props.item.isActive"
                    :color="props.item.hasUser ? 'error' : 'success'"
                    :disabled="props.item.hasUser || !$auth.user().AuthScope.includes('annotation:manage')"
                    @change="annotatorActiveStatusChanged(props.item)"
                  >
                  </v-switch>
                </td>
                <td><v-icon medium :color="props.item.hasUser ? 'error' : 'success'"> {{ props.item.hasUser ? 'lock' : 'lock_open' }} </v-icon></td>
                <td>{{ props.item.createdDate | formatDate }}</td>
                <td class="text-xs-right" v-if="$auth.user().AuthScope.includes('annotation:manage')">
                  <v-tooltip bottom :color="props.item.hasUser ? '' : 'accent'" v-if="$auth.user().AuthScope.includes('annotation:manage')">
                    <v-icon
                      class="mr-2"
                      color="accent"
                      slot="activator"
                      @click="$router.push(`/annotators/${props.item.id}/edit`)"
                      :disabled="props.item.hasUser"
                    >
                      edit
                    </v-icon>
                    <span>{{ props.item.hasUser ? `Cannot edit user locked annotator` : `Edit Item` }}</span>
                  </v-tooltip>
                  <v-tooltip bottom :color="props.item.hasUser ? '' : 'error'" v-if="$auth.user().AuthScope.includes('annotation:manage')">
                    <v-icon
                      color="error"
                      slot="activator"
                      :disabled="props.item.hasUser"
                      @click="dialog = true; itemToDelete = props.item;"
                    >
                      delete
                    </v-icon>
                    <span>{{ props.item.hasUser ? `Cannot delete user locked annotator` : `Delete Item` }}</span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
    v-model="dialog"
    max-width="500"
    v-if="$auth.user().AuthScope.includes('annotation:manage')"
    >
      <v-card>
        <v-card-title class="headline">Delete annotator</v-card-title>
        <v-card-text>
          Are you sure to delete this annotator?
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            flat
            depressed
            :disabled="deleteLoading"
            @click="dialog = false; itemToDelete = {};"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            depressed
            class="white--text"
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click.native="deleteItem()"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      headers: [
        {text: 'ID', sortable: true, value: 'id'},
        {text: 'Name', sortable: true, value: 'name'},
        {text: 'E-Mail', sortable: false, value: 'email'},
        {text: 'Phone Number', sortable: false, value: 'phoneNumber'},
        {text: 'Active', sortable: false, value: 'isActive'},
        {text: 'User Lock', sortable: false, value: 'hasUser'},
        {text: 'Created', sortable: true, value: 'createdDate'},
        {text: 'Actions', value: 'name', sortable: false, align: 'right'}
      ],
      items: [],
      dialog: false,
      logsToShow: [],
      itemToDelete: {},
      deleteLoading: false,
      annotatorsLoading: false,
      pagination: {
        sortBy: 'id'
      }
    }
  },
  created () {
    this.annotatorsLoading = true
    this.fetchAnnotators()
  },
  computed: {
    ...mapState({
      roleCollection: state => state.configurations.roles
    }),
    filteredHeaders () {
      if (!this.$auth.user().AuthScope.includes('annotation:manage')) {
        return this.headers.slice(0, 7)
      }
      return this.headers
    }
  },
  methods: {
    fetchAnnotators () {
      this.axios.get('/annotators')
        .then(response => {
          if (response.data) {
            this.items = response.data.map(annotator => ({
              id: annotator.id,
              firstName: annotator.first_name,
              lastName: annotator.last_name,
              email: annotator.email,
              user: annotator.user,
              phoneNumber: annotator.phone_number,
              createdDate: annotator.created_date,
              isActive: annotator.is_active,
              hasUser: !!annotator.user
            }))
          }
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.annotatorsLoading = false
        })
    },
    deleteItem () {
      this.deleteLoading = true
      this.axios.delete(`/annotators/${this.itemToDelete.id}`)
        .then(response => {
          let index = this.items.indexOf(this.itemToDelete)
          this.items.splice(index, 1)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.deleteLoading = false
          this.dialog = false
          this.itemToDelete = {}
        })
    },
    annotatorActiveStatusChanged (item) {
      this.axios.patch(`/annotators/${item.id}`, {
        is_active: item.isActive
      })
        .then(response => {
          this.$toast.open({
            text: item.isActive ? 'Activated' : 'Deactivated',
            type: 'success'
          })
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
    }
  }
}
</script>

<style>

</style>
